export default {
    section: 'Business Formation Information',
    name: 'entity-formation-business-information',
    questionWidth: 4,
    items: [
        {
            type: 'text-field',
            text: 'Business Name',
            name: 'entity-formation-business-name',
            props: {
                label: 'Business Name',
                tooltip: 'Provide the full legal name'
            }
        },
        {
            type: 'selectlist',
            text: 'State of Formation',
            name: 'entity-formation-state',
            width: 3,
            props: {
                items: [
                    // TODO Swap States
                    {
                        text: 'swap-states',
                        value: 'swap-states'
                    }
                ]
            }
        },
        {
            type: 'datepicker',
            text: 'Desired Date of Formation',
            name: 'entity-formation-date',
            width: 3,
            props: {
                label: 'Desired Date of Formation'
            }
        },
        {
            type: 'text-field',
            text: 'Legal Address',
            name: 'entity-formation-address-street',
            props: {
                label: 'Address'
            },
            subItems: [
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'entity-formation-address-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'entity-formation-address-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'entity-formation-address-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'County of Legal Address',
            name: 'entity-formation-address-county',
            props: {
                label: 'County'
            }
        },
        {
            type: 'text-field',
            text: 'Business Phone',
            name: 'entity-formation-business-phone',
            width: 3,
            props: {
                label: 'Business Phone',
                format: 'phone'
            }
        },
        {
            type: 'text-field',
            text: 'Business Fax',
            name: 'entity-formation-business-fax',
            width: 3,
            props: {
                label: 'Business Fax'
            }
        },
        {
            type: 'selectlist',
            text: 'Entity Type',
            name: 'entity-formation-type',
            width: 4,
            props: {
                tooltip: 'Consultation with your CPA/Attourney is advised in making this decision',
                items: [
                    // TODO: Swap Entity Types
                    {
                        text: 'swap-entity-types',
                        value: 'swap-entity-types'
                    }
                ]
            }
        },
        {
            type: 'selectlist',
            text: 'Subchapter S Election',
            name: 'entity-formation-subchapter-election',
            width: 4,
            props: {
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Will you be member-managed or manager-managed?',
            name: 'entity-formation-management',
            props: {
                items: [
                    {
                        text: 'Member-managed',
                        value: 'member-managed'
                    },
                    {
                        text: 'Manager-managed',
                        value: 'manager-managed'
                    }
                ]
            }
        },
        {
            type: 'textarea',
            text: 'Business Purpose',
            name: 'entity-formation-business-purpose',
            props: {}
        },
        {
            type: 'text-field',
            text: 'Number of Authorized Units/Shares (typically 100,000)',
            name: 'entity-formation-authorized-shares',
            width: 3,
            props: {
                label: 'Authorized Units/Shares',
                format: 'number'
            }
        },
        {
            type: 'text-field',
            text: 'Cost per Unit',
            name: 'entity-formation-cost-per-unit',
            width: 3,
            props: {
                label: 'Cost per Unit',
                format: 'dollars'
            }
        },
        {
            type: 'checkbox-list',
            text: 'Stock Types/Classes (if applicable)',
            name: 'entity-formation-stock-types',
            props: {
                items: [
                    {
                        text: 'Common Stock',
                        value: 'common'
                    },
                    {
                        text: 'Preferred Stock',
                        value: 'preferred'
                    },
                    {
                        text: 'Voting Stock',
                        value: 'voting'
                    },
                    {
                        text: 'Nonvoting Stock',
                        value: 'nonvoting'
                    }
                ]
            }
        },
        {
            type: 'text-field',
            text: 'Estimated Annual Revenue',
            name: 'entity-formation-annual-revenue',
            width: 3,
            props: {
                label: 'Estimated Annual Revenue',
                format: 'dollars',
                tooltip: 'Combined if multiple owners'
            }
        },
        {
            type: 'text-field',
            text: 'Estimated Annual Expenses',
            name: 'entity-formation-annual-expenses',
            width: 3,
            props: {
                label: 'Estimated Annual Expenses',
                format: 'dollars',
                tooltip: 'Combined if multiple owners'
            }
        },
        {
            type: 'text-field',
            text: 'Estimate AUM',
            name: 'entity-formation-aum',
            width: 3,
            props: {
                label: 'Estimate AUM',
                format: 'dollars',
                tooltip: 'Combined if multiple owners'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/entity-new/valuation-data/business-information.js